// import { isArguments } from 'lodash'
import { COMPONENT_BELONG_PAGE_TYPE_MAP } from './variable'
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}

export const isFormComponent = item => item.pageType && item.pageType.includes(COMPONENT_BELONG_PAGE_TYPE_MAP.FORM)

export const isCustomComponent = item => !item.pageType || item.pageType.includes(COMPONENT_BELONG_PAGE_TYPE_MAP.CUSTOM)

export const isListComponent = item => !item.pageType || item.pageType.includes(COMPONENT_BELONG_PAGE_TYPE_MAP.LIST)
